import { getAxiosConfig } from "@/services/axiosConfig";
import { IApiTokens, IApiTokensPost } from "@/types/all.types";

const version = process.env.NEXT_PUBLIC_API_VERSION as string;

const baseUrl = (process.env.NEXT_PUBLIC_API_URL + version) as string;

const baseUrlWithoutVersion = process.env.NEXT_PUBLIC_API_URL as string;

const baseUrlMail = process.env.NEXT_PUBLIC_MAIL_URL as string;

const multiMediaUrl = process.env.NEXT_PUBLIC_MEDIA_URL as string;

const api = {
  getApiTokens: async () => {
    const res = await getAxiosConfig().get<IApiTokens>("/user/api-tokens");
    return res.data;
  },
  postApiTokens: async () => {
    const res = await getAxiosConfig().post<IApiTokensPost>("/user/api-tokens");
    return res.data;
  },
  deleteApiTokens: async (id: number) => {
    const res = await getAxiosConfig().delete<IApiTokensPost>(`/user/api-tokens/${id}`);
    return res.data;
  },
};

export { baseUrl, multiMediaUrl, api, baseUrlWithoutVersion, baseUrlMail };
